// Dependencies
import { FC } from "react";

// Styles
import {
  StyledBarWrapper,
  StyledSearchIcon,
  StyledSearchInput,
} from "./SearchBar.styled";

interface SearchBarProps {}

const SearchBar: FC<SearchBarProps> = () => {
  return (
    <StyledBarWrapper>
      <StyledSearchInput
        placeholder={"Search"}
        InputProps={{
          startAdornment: <StyledSearchIcon />,
        }}
      />
    </StyledBarWrapper>
  );
};

export default SearchBar;
